<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './assets/css/main.css'
export default {
  name: 'App',
  watch: {
      $route: {
          handler: function(val, oldVal){
            if(val.path != "/login"||val.path != "/youXunCheck"){
              let kFu = document.getElementById('udesk_container')
              if(kFu)
              kFu.style.display = "none"
            }
          },
          deep: true
      }
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue